import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';
import * as moment from 'moment';

@Injectable()
export class TbillRecieptService {
  tbillReciept: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'tbill_reciept/list/?';
  private AddRecord = webapi + 'tbill_reciept/create';
  private AddRecordBillupdate = webapi + 'tbill_reciept/createupdatebill';
  private EditRecord = webapi + 'tbill_reciept/update';
  private GetRecord = webapi + 'tbill_reciept/byid/';
  private DeleteRecord = webapi + 'tbill_reciept/delete/';
  private LastRecord = webapi + 'tbill_reciept/lastReceipt';
  private ListRecordByBill = webapi + 'tbill_reciept/bybill/';
  private ListRecordByVisitIdTariffId = webapi + 'tbill_reciept/byVisitIdAndTariffId/';
  private refund = webapi + 'tbill_reciept/refund/';

  constructor(private http: Http) {
  }

  refundAmount(model: any,refundPaidAmount) {
    return this.http.post(this.refund + refundPaidAmount , JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordBillupdate(model: any) {
    return this.http.post(this.AddRecordBillupdate, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordByBill(billId: any, tariffId) {
    return this.http.get(this.ListRecordByBill + billId + '/' + tariffId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getRecordByVisitIdTariffId(visitID: any, tariffId) {
    return this.http.get(this.ListRecordByVisitIdTariffId + visitID + '/' + tariffId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  getLastRecord() {
    return this.http.get(this.LastRecord)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
    /*
         */
  }

  buildRecieptNumber() {
    let recipt: any = {};
    let currDate = new Date();
    let cuuDateTemp;
    cuuDateTemp = moment(currDate).format('DD/MM/YYYY');
    let lastrecieptNumber = '';
    let recieptNumber = '';
    let newRecieptNumber = 0;
    this.getLastRecord().then(response => {
      /*recipt = response;*/
      if (response != undefined || response != '' || response != ' ') {
        if (response.brRecieptNumber == null) {
          newRecieptNumber = 1;
          recieptNumber = 'RECPT' + '/' + cuuDateTemp + '/' + ('00000' + newRecieptNumber).slice(-6);
          alert('last Reciept Null');
          alert(recieptNumber);
        }
        else {
          lastrecieptNumber = recipt.brRecieptNumber;
          lastrecieptNumber = lastrecieptNumber.substring(13);
          newRecieptNumber = parseFloat(lastrecieptNumber) + 1;
          alert('New Bill' + newRecieptNumber);
          recieptNumber = 'RECPT' + '/' + cuuDateTemp + '/' + ('00000' + newRecieptNumber).slice(-6);
        }
      }
      else {
        newRecieptNumber = 1;
        recieptNumber = 'RECPT' + '/' + cuuDateTemp + '/' + ('00000' + newRecieptNumber).slice(-6);
      }
    });
    alert('RECPT NUMBER' + recieptNumber);
    return recieptNumber;
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/tbill-reciept/tbill-reciept.service.ts